import React, {PureComponent} from 'react';
import Frame from './frame';
import classes from './frames.module.scss';

export default class Frames extends PureComponent{
	render(){
		const leftWindow = this.props.pathimages + 'constructor/window-s.png',
			  rightWindow = this.props.pathimages + 'constructor/window-s2.png';

		const {onUpdateWindowsLeaf, typewindowdata, windowstypeleaf} = this.props;

		return(
			<div className={classes['wincalc-frames']}>
				<Frame
					activeClassElement = {windowstypeleaf[0]}
					idTypeWindowData = {1} // id типа окна в typeWindowData
					typewindowdata = {typewindowdata}
					img = {leftWindow}
					onUpdateWindowsLeaf = {onUpdateWindowsLeaf}
				 />
				<Frame
					activeClassElement = {windowstypeleaf[1]}
					idTypeWindowData = {2}
					typewindowdata = {typewindowdata}
					img = {rightWindow}
					onUpdateWindowsLeaf = {onUpdateWindowsLeaf}
				 />
				<Frame
					activeClassElement = {windowstypeleaf[2]}
					idTypeWindowData = {3}
					typewindowdata = {typewindowdata}
					img = {leftWindow}
					onUpdateWindowsLeaf = {onUpdateWindowsLeaf}
				 />
				<Frame
					activeClassElement = {windowstypeleaf[3]}
					idTypeWindowData = {4}
					typewindowdata = {typewindowdata}
					img = {rightWindow}
					onUpdateWindowsLeaf = {onUpdateWindowsLeaf}
				 />
			</div>
		)
	}
}